import { random } from 'lodash-es'
import { toJS } from 'mobx'
import { useEffect } from 'react'

import usePopup from '../../HYBVant/HPopup/hooks/usePopup'
import CityCascader from '../CityCascader'

export default ({
  healthCertificate,
  changeAllHealthCertificate,
  changeHealthCertificateStatus,
  changeEditHealthItem,
  onConfirm
}: any) => {
  const { open, modalData, onCancel, onOpen } = usePopup({})
  const dataFormat = async (data: any) => {
    const city_names = await CityCascader.getCityNames(data?.city_ids)
    return {
      ...data,
      id: data?.id || random(100000),
      health_start_at: data?.start_time || '',
      health_end_at: data?.end_time || '',
      city_names
    }
  }
  const add = () => {
    changeHealthCertificateStatus('Add')
    onOpen({ status: 'Add' })
  }

  const edit = (index: number) => {
    changeEditHealthItem(healthCertificate?.[index])
    changeHealthCertificateStatus('Edit')
    onOpen({ status: 'Edit' })
  }

  const runSaveHealth = async (data: any) => {
    if (data?.healths?.[0]) {
      const healthItem = await dataFormat({ id: data?.id, ...data?.healths?.[0] })
      const isEdit = healthCertificate?.findIndex((item: any) => item.id === healthItem.id) > -1
      const newHealthCertificates = healthCertificate?.map((item: any) => {
        if (item.id === healthItem?.id) {
          return healthItem
        }
        return item
      })
      changeAllHealthCertificate(
        isEdit ? newHealthCertificates : [...(healthCertificate || []), healthItem]
      )
    }
    onCancel()
  }

  const runDeleteHrmHealth = (data: any) => {
    const rest = healthCertificate.filter((item: any) => item.id !== data.id?.[0])
    changeAllHealthCertificate(rest)
    onCancel()
  }

  useEffect(() => {
    if (onConfirm) onConfirm(healthCertificate)
    console.log('healthCertificate:', toJS(healthCertificate))
  }, [healthCertificate])
  return {
    add,
    edit,
    open,
    modalData,
    onCancel,
    onOpen,
    runSaveHealth,
    runDeleteHrmHealth,
    runHhealthsEmployee: () => {},
    saveHealthLoading: false,
    deleteHrmHealthLoading: false
  }
}
